import lang from "@/views/modules/TicketSystems/language/en";
let metaList = [
    {
        label: lang.LBL_REQUEST_TO,
        link: true,
        columnName: 'assigned_user',
        width:'125',
    },{
        label: lang.LBL_REQUEST_BY,
        link: true,
        columnName: 'created_by',
        width:'125',
    },
    {
        label: lang.LBL_TICKET_TYPE,
        link: false,
        columnName: 'ticket_type',
    },
    {
        label: lang.LBL_ED_SUPPORT_REQUEST,
        link: false,
        columnName: 'ed_support',
    },
    {
        label: lang.LBL_DESCRIPTION,
        link: false,
        columnName: 'description',
    },
    {
        label: lang.LBL_TICKET_STATUS,
        link: false,
        columnName: 'status',
    },
];
const link_list = {
    routePath: 'ticketsystems',
    title: 'Recent Active Invitees',
    search:  {
        status: {
            key: 'status',
            value: ["Open"],
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }